import React, { useState, useEffect } from 'react';
import { Loader2, ExternalLink, Maximize2, Minimize2, RefreshCw } from 'lucide-react';

const CHATWOOT_URL = 'https://chat.evogametech.com';

export default function WhatsAppChatwoot() {
  const [loading, setLoading] = useState(true);
  const [fullscreen, setFullscreen] = useState(false);
  const [key, setKey] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, [key]);

  const refresh = () => {
    setLoading(true);
    setKey(k => k + 1);
  };

  return (
    <div className={fullscreen ? 'fixed inset-0 z-50 bg-gray-900' : 'h-full'}>
      <div className="flex items-center justify-between px-4 py-2 bg-gradient-to-r from-green-600 to-green-700 text-white">
        <div className="flex items-center gap-2">
          <svg viewBox="0 0 24 24" className="w-6 h-6 fill-current">
            <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347z"/>
          </svg>
          <h1 className="text-lg font-semibold">WhatsApp Live - Centro de Mensajes</h1>
        </div>
        
        <div className="flex items-center gap-2">
          <button onClick={refresh} className="p-2 hover:bg-white/20 rounded-lg transition-colors" title="Recargar">
            <RefreshCw className="w-5 h-5" />
          </button>
          <button onClick={() => window.open(CHATWOOT_URL, '_blank')} className="p-2 hover:bg-white/20 rounded-lg transition-colors" title="Abrir en nueva ventana">
            <ExternalLink className="w-5 h-5" />
          </button>
          <button onClick={() => setFullscreen(!fullscreen)} className="p-2 hover:bg-white/20 rounded-lg transition-colors" title={fullscreen ? 'Salir' : 'Pantalla completa'}>
            {fullscreen ? <Minimize2 className="w-5 h-5" /> : <Maximize2 className="w-5 h-5" />}
          </button>
        </div>
      </div>

      <div className="relative" style={{ height: fullscreen ? 'calc(100vh - 48px)' : 'calc(100vh - 120px)' }}>
        {loading && (
          <div className="absolute inset-0 flex items-center justify-center bg-gray-100 z-10">
            <div className="text-center">
              <Loader2 className="w-10 h-10 animate-spin text-green-600 mx-auto mb-3" />
              <p className="text-gray-600">Cargando centro de mensajes...</p>
            </div>
          </div>
        )}
        
        <iframe
          key={key}
          src={CHATWOOT_URL + '/app/accounts/1/conversations'}
          className="w-full h-full border-0"
          onLoad={() => setLoading(false)}
          allow="microphone; camera; clipboard-write"
          title="WhatsApp Chat"
        />
      </div>
    </div>
  );
}
